import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import mapData from './data'

const mapName = '城市名称'
const aspectScale = 0.85
const layoutSize = '100%'
const zoom = 1

// const allData = [
//     { name: '济南市', values: {a: 123} },
//     { name: '青岛市', values: {a: 123} },
//     { name: '烟台市', values: {a: 123} },
//     { name: '潍坊市', values: {a: 123} },
//     { name: '菏泽市', values: {a: 123} },
//     { name: '日照市', values: {a: 123} },
//     { name: '威海市', values: {a: 123} },
//     { name: '枣庄市', values: {a: 123} },
//     { name: '临沂市', values: {a: 123} },
//     { name: '滨州市', values: {a: 123} },
//     { name: '东营市', values: {a: 123} },
//     { name: '淄博市', values: {a: 123} },
//     { name: '泰安市', values: {a: 123} },
//     { name: '聊城市', values: {a: 123} },
//     { name: '济宁市', values: {a: 123} },
//     { name: '德州市', values: {a: 123} },
// ];

const interval = 1500

export default /*#__PURE__*/_defineComponent({
  __name: 'MapCpn',
  setup(__props) {

const layoutCenter = ['50%', '50%']
const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)

const containerRef = ref()
const myChart = ref()



const option = computed(() => {
    return {
        tooltip: {
            show: true,
            position: (point: any, params: any, dom: any, rect: any, size: any) => {
                return [point[0] - 20, point[1] - size.contentSize[1] - 15];
            },
            // eslint-disable-next-line
            formatter: (params: any) => {
                if (params.data)
                    return (
                        `
                                <div>
                                    <div style="display: flex; color: #ffffff; font-size: 1.8rem;">
                                        <span style="flex: 1;">${params.name}</span>
                                        <span style="flex: 1;">申请量${params.data['values']['applicationVolume']}</span>
                                    </div>
                                    <div style="display: flex; font-size: 1.6rem; margin-top: 1rem;">
                                        <div style="flex: 1;">
                                            <div style="color: #1FC6FF;">发明申请</div>
                                            <div style="color: #ffffff; margin-top: 0.5rem;">${params.data['values']['inventionApplication']}</div>
                                        </div>
                                        <div style="flex: 1;">
                                            <div style="color: #1FC6FF;">实用新型</div>
                                            <div style="color: #ffffff; margin-top: 0.5rem;">${params.data['values']['utilityModel']}</div>
                                        </div>
                                    </div>
                                    <div style="display: flex; font-size: 1.6rem; margin-top: 1rem;">
                                        <div style="flex: 1;">
                                            <div style="color: #1FC6FF;">有效发明</div>
                                            <div style="color: #ffffff; margin-top: 0.5rem;">${params.data['values']['effectiveInvention']}</div>
                                        </div>
                                        <div style="flex: 1;">
                                            <div style="color: #1FC6FF;">PCT申请</div>
                                            <div style="color: #ffffff; margin-top: 0.5rem;">${params.data['values']['pct']}</div>
                                        </div>
                                    </div>
                                </div>
                            `
                    );
            },
            extraCssText: "background-color: rgba(11, 33, 88, 0.68); width: 31.5rem; border: 2px solid #1FC6FF;",
        },
        geo: {
            map: mapName,
            zoom: zoom, //当前视角的缩放比例
            aspectScale: aspectScale,
            layoutCenter: layoutCenter, //地图位置
            layoutSize: layoutSize,
            itemStyle: {
                normal: {
                    shadowColor: 'rgba(128, 217, 248, 1)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 6,
                    shadowBlur: 0,
                },
                emphasis: {
                    areaColor: '#389BB7',
                    borderWidth: 0,
                },
            },
        },
        series: [
            {
                name: 'Map',
                type: 'map',
                mapType: mapName,
                selectedMode: 'false', //是否允许选中多个区域
                zoom: zoom, //当前视角的缩放比例
                aspectScale: aspectScale,
                layoutCenter: layoutCenter, //地图位置
                layoutSize: layoutSize,
                label: {
                    normal: {
                        show: true,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: '1.2rem'
                        }
                    },
                    emphasis: {
                        textStyle: {
                            color: '#1C34A0',
                            fontSize: '1.2rem'
                        }
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: '#1C34A0',
                        borderColor: '#72FEFC',
                    },
                    shadowColor: '#72FEFC',
                    emphasis: {
                        areaColor: '#72FEFC',
                        borderColor: '#FFF',
                        borderWidth: '0.1rem',
                        shadowBlur: 0,
                        label: {
                            show: true,
                            textStyle: {
                                color: '#FFF',
                                fontSize: '1.6rem',
                            },
                        },
                    },
                },
                data: data.value?.map || [],
            },
        ]
    }
})

onMounted(() => {
    setTimeout(() => {
        createChart()
    }, 500)
})

onMounted(() => {
    window.addEventListener('resize', handleResize)
})
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

let activeIndex = 0
let mapTimer: number | number

const initInterval = () => {
    const onStop = watch(() => data.value?.map, (map) => {
        console.log('test');
        
        if (map) {
            dispatchActionChart("highlight", activeIndex);
            dispatchActionChart("showTip", activeIndex);
            setIntervalMyChart();

            // 鼠标划入
            mouseEvents();

            onStop && onStop()
        }
    },
    {immediate: true})

}

// 设置地图轮播
const setIntervalMyChart = () => {
    const dataLength = (data.value?.map as any).length;
    // 每隔 interval 进行一次切换
    mapTimer = setInterval(() => {
        // 清除高亮跟提示
        dispatchActionChart("downplay", activeIndex);
        dispatchActionChart("hideTip", activeIndex);
        // 索引增加
        activeIndex++;
        // 激活高亮跟提示
        dispatchActionChart("highlight", activeIndex);
        dispatchActionChart("showTip", activeIndex);
        if (activeIndex === dataLength - 1) {
            // 需要对最后一个进行清除，对第一个进行激活
            let tempTimer = setTimeout(() => {
                dispatchActionChart("downplay", dataLength - 1);
                dispatchActionChart("highlight", activeIndex);
                clearTimeout(tempTimer);
            }, interval);
            activeIndex = -1;
        }
    }, interval);
}

// 鼠标移入效果
const mouseEvents = () => {
    myChart.value.on("mouseover", () => {
        // 停止定时器，清除之前的高亮
        clearInterval(mapTimer);
        dispatchActionChart("downplay", activeIndex);
    });
    // 鼠标划出重新定时器开始
    myChart.value.on("mouseout", () => {
        clearInterval(mapTimer);
        // 启动轮播
        setIntervalMyChart();
    });
}

// 高亮方法
const dispatchActionChart = (type: 'highlight' | 'downplay' | 'showTip' | 'hideTip', dataIndex: number) => {
    myChart.value.dispatchAction({
        type: type,
        seriesIndex: 0,
        dataIndex: dataIndex,
    });
}

const handleResize = () => {
    myChart.value?.resize()
}

const createChart = async () => {
    myChart.value = echarts.init(containerRef.value);
    echarts.registerMap(mapName, mapData as any);
    myChart.value.setOption(option.value);

    initInterval()

}

watch(
    option,
    () => { myChart.value?.setOption(option.value) },
    { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "technical-proposal",
    ref_key: "containerRef",
    ref: containerRef
  }, null, 512))
}
}

})